<template>
<div>
    <div class="commodityDistributionSetting padding-20 bgc box-shadow">
        <!-- 商品分销开关 -->
        <div class="distributionSwitch">
            <div class="first-rank">
                <span class="title">商品分销</span>
                <el-switch @click.native="openCloseSwitch" v-model="openClose"></el-switch>
                <span v-if="openClose" class="openText">已开启</span>
                <span v-else class="closeText">已关闭</span>
            </div>
            <div class="secound-rank">{{extensionAgent}}</div>
            <div class="three-rank"><a href="www.baidu.com">使用教程</a></div>
        </div>
        <div class="distributionBox" v-if="openClose">
            <distribution :innerid="innerid"></distribution>
        </div>
    </div>
    
</div>
</template>
<script>
import Distribution from './components/Distribution'
import {getDistributionStatus, openCloseDistribution} from '@/api/distribution'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'commodityDistributionSetting',
    data() {
        return {
            openClose: false,
            extensionAgent: '推广员是内容发布平台推出的一款可帮助商户拓宽推广渠道的应用营销工具，商户在买家成功推广课程后给予其奖励，以此给商户带来更多传播和促进销量提升。通过推广员产生的订单收益会自动存入可提现余额中，您可随时申请提现。',
            innerid: ''
        }
    },
    created() {
        this.getStatus()
    },
    methods: {
        getStatus() {
            this.setLoading(true)
            getDistributionStatus({
                data: {},
                success: data => {
                    this.setLoading(false)
                    this.openClose = data.data.isopendistribute ? true : false
                    this.innerid = data.data.innerid
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        openCloseDistribution(v, value) {
            this.setLoading(true)
            openCloseDistribution({
                data: {innerid: this.innerid, isopendistribute: v},
                success: data => {
                    this.setLoading(false)
                    if (v) {
                        this.$message({
                            type: 'success',
                            message: '打开成功'
                        })
                    } else {
                        this.$message({
                            type: 'success',
                            message: '关闭成功'
                        })
                    }
                    
                },
                error: data => {
                    this.setLoading(false)
                    this.openClose = value
                    this.$message.error(data.msg)
                }
            })
        },
        openCloseSwitch() {
            if (this.openClose) {
                this.openCloseDistribution(1, false)
            } else {
                this.openCloseDistribution(0, true)
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        // 'openClose': {
        //     handler(newV, oldV) {
        //         if (newV) {
        //             this.openCloseDistribution(1, oldV)
        //         } else {
        //             this.openCloseDistribution(0, oldV)
        //         }
        //     }
        // }
    },
    components: {
        Distribution
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .commodityDistributionSetting{
        height: 100%;
        .distributionSwitch{
            height: 142px;
            background: #F5F7FA;
            box-sizing: border-box;
            padding: 20px;
            .first-rank{
                line-height: 25px;
                .title{
                    font-size: 20px;
                    color: #303133;
                }
                .el-switch{
                    margin: 0 20px;
                }
                .openText,.closeText{
                    color: #909399;
                    font-size: 14px;
                }
            }
            .secound-rank{
                margin: 20px 0;
            }
            .three-rank{
                a{
                    color: #409EFF;
                }
            }
        }
    }
    .btnBox{
        line-height: 20px;
        text-align: center;
        box-sizing: border-box;
        margin-top: 10px;
    }
</style>
